export const httpCode = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_ACCEPTABLE: 406,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
};
